import "./task.css";
import { useState } from "react";
import TaskItem from "../TaskItem/TaskItem";
import EditTask from "../EditTask/EditTask";
import { doc, updateDoc, deleteDoc } from "firebase/firestore";
import { db } from "../../../firebase";

function Task({
  id,
  name,
  surname,
  username,
  age,
  followers,
  city,
  email,
  completed,
}) {
  const [checked, setChecked] = useState(completed);
  const [open, setOpen] = useState({ edit: false, view: false });

  const handleClose = () => {
    setOpen({ edit: false, view: false });
  };

  /* function to update firestore */
  const handleChange = async () => {
    const taskDocRef = doc(db, "users", id);
    try {
      await updateDoc(taskDocRef, {
        completed: checked,
      });
    } catch (err) {
      alert(err);
    }
  };

  /* function to delete a document from firstore */
  const handleDelete = async () => {
    const taskDocRef = doc(db, "users", id);
    try {
      await deleteDoc(taskDocRef);
    } catch (err) {
      alert(err);
    }
  };

  return (
    <>
      <tr>
        <td>{name}</td>
        <td>{surname}</td>
        <td>{followers}</td>
        <td>
          <button
            className="instagram"
            onClick={() => {
              window.open(`https://www.instagram.com/` + username, "_blank");
            }}
          >
            Instagram
          </button>
        </td>
        <td>
          <button
            className="view"
            onClick={() => setOpen({ ...open, view: true })}
          >
            View
          </button>
        </td>
        <td>
          <div>
            <input
              id={`checkbox-${id}`}
              className="checkbox-custom"
              name="checkbox"
              checked={checked}
              onChange={handleChange}
              type="checkbox"
            />
            <label
              htmlFor={`checkbox-${id}`}
              className="checkbox-custom-label"
              onClick={() => setChecked(!checked)}
            >
              Onayla
            </label>
          </div>
        </td>
        <td>
          <button
            className="task__editButton"
            onClick={() => setOpen({ ...open, edit: true })}
          >
            Edit
          </button>
        </td>
        <td>
          <button className="task__deleteButton" onClick={handleDelete}>
            Delete
          </button>
        </td>
      </tr>

      {open.view && (
        <TaskItem
          onClose={handleClose}
          name={name}
          surname={surname}
          username={username}
          followers={followers}
          age={age}
          city={city}
          email={email}
          open={open.view}
        />
      )}

      {open.edit && (
        <EditTask
          onClose={handleClose}
          toEditName={name}
          toEditSurname={surname}
          toEditUsername={username}
          toEditAge={age}
          toEditFollowers={followers}
          toEditCity={city}
          toEditEmail={email}
          open={open.edit}
          id={id}
        />
      )}
    </>
  );
}

export default Task;
{
  /* <div>
        <input
          id={`checkbox-${id}`}
          className="checkbox-custom"
          name="checkbox"
          checked={checked}
          onChange={handleChange}
          type="checkbox"
        />
        <label
          htmlFor={`checkbox-${id}`}
          className="checkbox-custom-label"
          onClick={() => setChecked(!checked)}
        >
        Onayla
        </label>
        </div>
        <div className="task__body">
        <h2>{name}</h2>
        <p>{surname}</p>
        <button
          onClick={() => {
            window.open(`https://www.instagram.com/` + username, "_blank");
          }}
        >
        Instagram
        </button>
        <p>{followers}</p>
        <p>{age}</p>
        <p>{city}</p>
        <p>{email}</p>
        <div className="task__buttons">
        <div className="task__deleteNedit">
            <button
            className="task__editButton"
            onClick={() => setOpen({ ...open, edit: true })}
            >
              Edit
              </button>
            <button className="task__deleteButton" onClick={handleDelete}>
              Delete
              </button>
              </div>
              <button onClick={() => setOpen({ ...open, view: true })}>View</button>
              </div>
            </div> */
}
